import { GradeReview } from '@/plugins/api'
import alert from '@/plugins/alert'

/* eslint-disable no-unused-vars */
export default {
  namespaced: true,
  actions: {
    async fetchGradeReviews({ commit }, options) {
      const subGroups = await GradeReview.fetch({ ...options })
      return subGroups
    },
    async fetchGradeReview({ commit }, id) {
      const subGroup = await GradeReview.fetchOne(id)
      return subGroup
    },
    async createGradeReview({ commit }, data) {
      const subGruop = await GradeReview.create(data)
      return subGruop
    },
    async updateGradeReview({ commit }, { id, ...data }) {
      const updatedGroup = await GradeReview.update(id, { ...data })
      return updatedGroup
    },
    async countGradeReviews({ commit }, options) {
      try {
        return await GradeReview.count(options)
      } catch (e) {
        alert.error(e)
      }
    },
  },
}
/* eslint-disable no-unused-vars */
